// ==============================================================================
// UHS we use this file
// ==============================================================================

// When the document is ready
$(document).ready(function() {
  const sections = $("[data-countdown-section-id]");
  let targetDate;

  // Sets the countdowns initially
  sections.each(function() {
    targetDate = setTargetDate($(this));
    $(this).find(".custom-countdown__timer").html(setCountdownString(targetDate));
  });

  // Updates every second
  setInterval(function() {
    sections.each(function() {
      targetDate = setTargetDate($(this));
      $(this).find(".custom-countdown__timer").html(setCountdownString(targetDate));
    });
  }, 1000);
});

// Function to set the target date based on the information passed by the section
function setTargetDate(element) {
  const targetDate = new Date();

  const year = $(element).data("year");
  const month = $(element).data("month");
  const date = $(element).data("date");
  const hour = $(element).data("hour");
  const minute = $(element).data("minute");

  targetDate.setFullYear(year);
  targetDate.setUTCMonth(month);
  targetDate.setUTCDate(date);
  targetDate.setUTCHours(hour);
  targetDate.setUTCMinutes(minute);
  targetDate.setUTCSeconds(0);

  return targetDate;
}

// Function to create the countdown string
function setCountdownString(targetDate) {
  const now = new Date();
  const countdown = targetDate - now;

  const days = Math.floor(countdown / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
  const hours = Math.floor((countdown / (1000 * 60 * 60)) % 24).toString().padStart(2, '0');
  const minutes = Math.floor((countdown / (1000 * 60)) % 60).toString().padStart(2, '0');

  if (countdown >= 0) {
    return `${days}d ${hours}h ${minutes}m`;
  } else {
    return "00d 00h 00m";
  }
}














